import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/joy/Box";

import Header from "../components/common/Header";
import Sidebar from "../components/common/Sidebar";
import MainContent from "../components/common/MainContent";

const MainLayout = () => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "var(--joy-palette-background-body)",
      }}
    >
      <Header />
      <Sidebar />
      <MainContent>
        <Outlet />
      </MainContent>
    </Box>
  );
};

export default MainLayout;
